// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class Color {
    static readonly Reset: string = '\x1b[0m';
    static readonly Bright: string = '\x1b[1m';
    static readonly Dim: string = '\x1b[2m';
    static readonly Underscore: string = '\x1b[4m';
    static readonly Blink: string = '\x1b[5m';
    static readonly Reverse: string = '\x1b[7m';
    static readonly Hidden: string = '\x1b[8m';
    static readonly FgBlack: string = '\x1b[30m';
    static readonly FgRed: string = '\x1b[31m';
    static readonly FgGreen: string = '\x1b[32m';
    static readonly FgYellow: string = '\x1b[33m';
    static readonly FgBlue: string = '\x1b[34m';
    static readonly FgMagenta: string = '\x1b[35m';
    static readonly FgCyan: string = '\x1b[36m';
    static readonly FgWhite: string = '\x1b[37m';
    static readonly FgGray: string = '\x1b[90m';
    static readonly BgBlack: string = '\x1b[40m';
    static readonly BgRed: string = '\x1b[41m';
    static readonly BgGreen: string = '\x1b[42m';
    static readonly BgYellow: string = '\x1b[43m';
    static readonly BgBlue: string = '\x1b[44m';
    static readonly BgMagenta: string = '\x1b[45m';
    static readonly BgCyan: string = '\x1b[46m';
    static readonly BgWhite: string = '\x1b[47m';
    static readonly BgGray: string = '\x1b[100m';

    static colorString(color: string, msg: string): string {
        return `${color}${msg}${Color.Reset}`;
    }
}
